import { Component, NgZone, OnInit, ElementRef, ViewChild } from '@angular/core';
import { AppDataService } from '../../app.data.service';
import { SocialLink } from '../../app.models';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { VisitorMapAndHours, VisitorMapAndHoursList, VisitorMapAndHoursService } from '../../../generated';

declare var $: any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @ViewChild('newsletterForm', {static: true}) newsletterForm: HTMLFormElement;

  instagramLink: SocialLink;
  facebookLink: SocialLink;
  youtubeLink: SocialLink;
  tripadvisorLink: SocialLink;
  visitorMapAndHoursData: VisitorMapAndHours;
  drawers = [];
  drawerToggles = [];
  ratings = null;

  constructor(private ngZone: NgZone,
              private appDataService: AppDataService,
              private router: Router,
              private elem: ElementRef,
              private toastr: ToastrService,
              private readonly visitorMapAndHoursService: VisitorMapAndHoursService,
              private httpClient: HttpClient) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.drawerToggles.forEach(dt => {
        dt.classList.remove('active');
      });
      this.drawers.forEach(d => {
        d.classList.remove('active');
      });
    });
  }

  async ngOnInit() {
    this.drawers = this.elem.nativeElement.querySelectorAll('.drawer');
    this.drawerToggles = this.elem.nativeElement.querySelectorAll('.drawer-toggle');
    // console.log(this.drawerToggles, this.drawers);

    this.instagramLink = await this.appDataService.getSocialLink('Instagram');
    this.facebookLink = await this.appDataService.getSocialLink('Facebook');
    this.youtubeLink = await this.appDataService.getSocialLink('YouTube');
    this.tripadvisorLink = await this.appDataService.getSocialLink('Tripadvisor');

    // this.getRatings();
    this.getVisitorMap();
  }

  toggleDrawer(id, event) {
    const div = document.getElementById(id);
    const target = event.target || event.srcElement || event.currentTarget;
    div.classList.toggle('active');
    target.classList.toggle('active');
  }

  goto(href) {
  //console.log('goto', href);
    window.open(href, '_blank');
  }

  async getRatings() {
    // console.log('rating');
    const ratings: any = await this.httpClient.get('/.netlify/functions/ratings').toPromise();
    if (!!ratings) {
      this.ratings = ratings;
      // console.log('ratings', ratings);
      setTimeout(() => {
        const el = document.querySelector('footer .rating .stars-inner') as HTMLElement;
        el.style.width = `${ratings.rating}%`;
      }, 1000);
    }
  }

  async getVisitorMap() {
    const visitorMapList: VisitorMapAndHoursList = await this.visitorMapAndHoursService.getOrgsOrgnameVisitormapandhours('global', true).toPromise();
    // console.log('DEBUG', visitorMapList);
    if (!!visitorMapList && !!visitorMapList[0]) {
      this.visitorMapAndHoursData = visitorMapList[0];
    }
    // console.log('VisitMap Data', this.visitorMapAndHoursData);
  }

  async onSubmit(event) {
    event.preventDefault();

    const $form = $('#newsletterFormDesktop');
    const $form2 = $('#newsletterFormMobile');

    const input1 = $form.find('input[name="email1"]').val();
  //console.log('INPUT1', input1);
    const input2 = $form.find('input[name="email2"]').val();
  //console.log('INPUT2', input2);

    let email;
    if (input1.length > 0) {
      email = encodeURIComponent($form.find('input[name="email1"]').val());
    } else {
      email = encodeURIComponent($form.find('input[name="email2"]').val());
    }

    window.open(`https://ui.constantcontact.com/d.jsp?m=1101527824990&p=oi&ea=${email}`, '_blank');

    // let data;
    //
    // const $form = $('#newsletterFormDesktop');
    // const $form2 = $('#newsletterFormMobile');
    //
    // const input1 = $form.find('input[name="email1"]').val();
    // console.log('INPUT1', input1);
    // const input2 = $form.find('input[name="email2"]').val();
    // console.log('INPUT2', input2);
    //
    // if (input1.length > 0) {
    //   data = new HttpParams().set('form-name', 'newsletter-signup').append('email', $form.find('input[name="email1"]').val());
    // } else {
    //   data = new HttpParams().set('form-name', 'newsletter-signup').append('email', $form2.find('input[name="email2"]').val());
    // }
    //
    // console.log('form submitting', data);
    //
    // this.httpClient.post('/', data, {
    //   observe: 'response',
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded',
    //     'Accept': 'text/html, application/xhtml+xml, */*'
    //   },
    //   responseType: 'text'
    // }).toPromise().then(res => {
    // //console.log('submitted form', res);
    //   this.toastr.success('Sucessfully subscribed!', 'Newsletter Subscription');
    //   $form[0].reset();
    // }).catch(err => {
    //   console.error('error submitting form', err);
    //   this.toastr.warning('Unable to subscribe, please try again later', 'Newsletter Subscription');
    // //console.log(data);
    // });
  }

}
